import api from "./api";

class RoleManager {

    roles(config?: any) {
        return api.get(`/roles`, config)
    }

    role(id: number | string) {
        return api.get(`/roles/${id}`)
    }

    rolePermissions(id: number | string) {
        return api.get(`/roles/${id}/permissions`)
    }

    savePermissions(id: number | string, data: any) {
        return api.post(`/roles/${id}/permissions`, data)
    }

    list = this.roles
    retrieve = this.role
    paginatedList = this.roles
}

const roleManager = new RoleManager()

export default roleManager
